import React from 'react'
import PropTypes from 'prop-types'

import { MDXContent } from './Content'
import './PageHeader.css'

const PageHeader = ({
  title,
  large,
  subtitle,
  backgroundImage,
  className = ''
}) => {
  if (large) className += ' PageHeader-large'

  return (
    <div className="container relative">
      <header
        className={`PageHeader ${className} ${backgroundImage &&
          `PHBackgroundImage`}`}
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : `none`
        }}
      >
        {subtitle ? (
          <div className="PageHeader--Title--2">
            <p>{title}</p>
            {subtitle && <MDXContent src={subtitle} />}
          </div>
        ) : (
          <>
            <h1 className="PageHeader--Title">{title}</h1>
            {subtitle && (
              <MDXContent className="PageHeader--Subtitle" src={subtitle} />
            )}
          </>
        )}
      </header>
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
}

export default PageHeader
